<template>
  <v-container
    id="contrato"
    fluid
    tag="section"
    class="parent-container"
    style="height: calc(90vh - 65px); background-color: var(--app-bg); padding: 0; margin: 0;"
  >
    <div>
      <img
        src="../../assets/pulse_v1.png"
        width="80%"
        style="max-width: 300px"
      />
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Inicio",

  components: {},

  data() {
    return {};
  },

  mounted() {
    this.$store.commit("SET_DRAWER", true);
  },

  methods: {},
};
</script>

<style scoped>
.parent-container {
  display: flex;
  justify-content: center; /* Centralizar horizontalmente */
  align-items: center; /* Centralizar verticalmente */
}

.parent-container img {
  max-width: 100%;
  max-height: 100%;
}
</style>
